import React, { useState } from "react";
import Image from "next/image";
import DoneIcon from "~/icons/done.svg";
import styles from "./HeadingWithBullets.module.scss";
import cn from "clsx";
import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue } from "@/context/utils";
import ArrowSVG from "@/SvgIcons/ArrowDown";
import Markdown from "@/components/atoms/Markdown";

export default function PerCurriculum({
  courseCurriculumTitle,
  index,
  item,
}) {
  const [isCurriculum, setisCurriculum] = useState(false);
  const [isCurriculumSectionOpen, setIsCurriculumSectionOpen] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const [openSection, setOpenSection] = useState<number | null>(null);

  const toggleSection = (index: number | null) => {
    if (openSection === index) {
      setOpenSection(null);
    } else {
      setOpenSection(index);
    }
  };

  const handleGAEvents = ({ heading, index }) => {
    pushToDataLayer({
      event: "card_details_interaction",
      cta_text: heading,
      section_name: courseCurriculumTitle,
      action: openSection === index ? "Collapse" : "Expand",
      page_type: getGlobalStateValue("pageType"),
    });
  };

  const certification = item?.CertificationJSON;

  const onClickProgramHandler = () => {
    setisCurriculum(false);
  };

  const onClickCertificationHandler = () => {
    setisCurriculum(true);
    setIsCurriculumSectionOpen(true);
  };

  const toggleCurriculum = (index) => {
    setSelectedIndex(index);
  };


  return (
    <div>
      <div className={cn("lining-nums", styles.HeadingWithBullets__textContainer)}>
        {/* Heading */}
        <div
          className="cursor-pointer flex justify-between items-center text-primary-blue"
          onClick={() => {
            handleGAEvents({ heading: item.heading, index });
            toggleSection(index);
          }}
        >
          <h3 className={cn(styles.HeadingWithBullets__title)}>{item.heading}</h3>
          <span className={styles.icon}>
            <ArrowSVG
              rotate={openSection === index ? 180 : 0}
              width={16}
              height={16}
              isActive={openSection === index}
              color="blue"
            />
          </span>
        </div>
        {/* Subtitle */}
        {openSection === index && (
          <div className="mt-4">
            {certification && (
              <div className={styles.dropDownWrapper}>
                <button
                  className={
                    !isCurriculum ? styles.dropdownButtons : styles.dropdownButtonsUnselected
                  }
                  onClick={onClickProgramHandler}
                >
                  Program Curriculum
                </button>
                <button
                  className={
                    isCurriculum ? styles.dropdownButtons : styles.dropdownButtonsUnselected
                  }
                  onClick={onClickCertificationHandler}
                >
                  Certification Curriculum
                </button>
              </div>
            )}

            {/* //? First item won't have \n so it will have issue in split we can use filter but that increases complexity so just prepanding \n so split can work normally */}
            {isCurriculum && (
              <>
                {certification?.map(({ Question, Answer }, index) => (
                  <div className={styles.subHeadingContainer}>
                    <div onClick={() => toggleCurriculum(index)} className={styles.subHeading}>
                      <div>{Question}</div>{" "}
                      <ArrowSVG
                        rotate={index === selectedIndex ? 180 : 0}
                        width={16}
                        height={16}
                        isActive={openSection === index}
                        color="blue"
                      />
                    </div>

                    {isCurriculum && isCurriculumSectionOpen && index === selectedIndex && (
                      <>
                        <div className={styles.curriculumSection}>
                          {Answer?.map((i: string, ind: number) => (
                            <p key={ind} className="flex gap-2 items-start">
                              <p className="mt-1">
                                <Image src={DoneIcon} alt="Done" />
                              </p>
                              <Markdown as="p" className={cn(styles.HeadingWithBullets__subtitle)}>
                                {i}
                              </Markdown>
                            </p>
                          ))}
                        </div>
                      </>
                    )}
                  </div>
                ))}
              </>
            )}

            {!isCurriculum &&
              ("\n" + item.subtitle)
                .split("\n-")
                .slice(1)
                .map((i: string, ind: number) => (
                  <p key={ind} className="flex gap-2 items-start">
                    <p className="mt-1">
                      <Image src={DoneIcon} alt="Done" />
                    </p>
                    <Markdown as="p" className={cn(styles.HeadingWithBullets__subtitle)}>
                      {i?.replace(/\n/gi, "  \n")}
                    </Markdown>
                  </p>
                ))}
          </div>
        )}
      </div>
      <hr className="text-[#D4D4D4] stroke-[1.5px]" />
    </div>
  );
}
